import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ChipComponent } from './components/design/chip/chip.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { MaterialModule } from './material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { SlideUpCardComponent } from './components/design/slide-up-card/slide-up-card.component';
import { FormsModule } from '../@forms/forms.module';
import { BottomSheetComponent } from './components/design/bottom-sheet/bottom-sheet/bottom-sheet.component';
import { DialogComponent } from './components/design/dialog/dialog/dialog.component';
import { PopUpModule } from './pop-up.module';
import { RoutePlannerHeaderComponent } from './components/route-planner/tariff-profile/route-planner-header/route-planner-header.component';
import { IconsModule } from './icons.module';
import { LoaderComponent } from './components/loader/loader.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { TariffProfileSelectorComponent } from './components/route-planner/tariff-profile/tariff-profile-selector/tariff-profile-selector.component';
import { TariffProfilePriceComponent } from './components/route-planner/tariff-profile/tariff-profile-price/tariff-profile-price.component';
import { LogoComponent } from './components/logo/logo.component';
import { SideMenuComponent } from './components/route-planner/side-menu/side-menu.component';
import { A11yModule } from '@angular/cdk/a11y';
import { ContactViewComponent } from './components/contact-view/contact.view.component';
import { MatTabPaginationA11yDirective } from './directives/mat-tab-pagination-a11y.directive';

@NgModule({ declarations: [
        ChipComponent,
        NavBarComponent,
        SlideUpCardComponent,
        RoutePlannerHeaderComponent,
        BottomSheetComponent,
        DialogComponent,
        LoaderComponent,
        TariffProfileSelectorComponent,
        TariffProfilePriceComponent,
        LogoComponent,
        SideMenuComponent,
        MatTabPaginationA11yDirective,
    ],
    exports: [
        A11yModule,
        MaterialModule,
        IconsModule,
        ChipComponent,
        NavBarComponent,
        SlideUpCardComponent,
        RoutePlannerHeaderComponent,
        LoaderComponent,
        TariffProfileSelectorComponent,
        TariffProfilePriceComponent,
        LogoComponent,
        SideMenuComponent,
        MatTabPaginationA11yDirective,
    ], imports: [CommonModule,
        RouterModule,
        A11yModule,
        MaterialModule,
        IconsModule,
        PopUpModule,
        ReactiveFormsModule,
        MatNativeDateModule,
        FormsModule,
        MaterialModule,
        MatProgressSpinnerModule,
        ContactViewComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule { }
